import React, { useEffect, useState, Fragment} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container, Row, Col, Form, Button} from 'react-bootstrap'
import {useFormik} from 'formik'
import { validationSchemas } from '../../common/validation-Schemas-informes'
import { obtenerEstados, obtenerCriteriosFecha, obtenerCriteriosPendiente, obtenerInformesPrevios, generarInforme} from '../../store/actions/informes-administracion-action'
import { Auth, LoadingComponent } from 'recupero-comunes'

const FiltrosInforme = () => {
    const [loading, setLoading]=useState(false)
    const data_informes = useSelector((state) => state.informeAdministracionReducer)
    const { cfg_formInf, tiposInforme, companias, estados, situaciones, criteriosFecha, criteriosPendiente, respuestaGenerar} = data_informes
    const {rutUsuario, rutOrganizacion}=Auth.currentUser()
    const dispatch = useDispatch()
    const [tipoGestion, setTipoGestion]=useState(null)
    
    const [isDias, setIsDias]=useState(false)
    const [isFechas, setIsfechas]=useState(false)

    const formik = useFormik({
        initialValues: {
          "rutcia": '',
          "rutusr":'',
          "tipoInforme": '',
          "compania": '',
          "estado": '', 
          "situacion": '', 
          "fechadesde": '',
          "fechahasta": '', 
          "criterioFecha": '', 
          "dias": '',          
          "criterioPendiente": '', 
        },
        validationSchema: validationSchemas(isDias, isFechas),
        onSubmit: (formData) => {
            setLoading(true)
            const dataForm = {};// {...formData}

            dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
            dataForm['rutusr'] = rutUsuario && rutUsuario     
            dataForm['tipoInforme'] = formData.tipoInforme ? {id: formData.tipoInforme, glosa: tiposInforme.find(element => element.id == formData.tipoInforme).nombre} : {};       
            dataForm['compania'] = formData.compania ? {id: formData.compania, glosa: companias.find(element => element.id == formData.compania).nombre} : {};       
            dataForm['estado'] = formData.estado ? {id: formData.estado, glosa: estados.find(element => element.id == formData.estado).nombre} : {};       
            dataForm['situacion'] = formData.situacion ? {id: formData.situacion, glosa: situaciones.find(element => element.id == formData.situacion).nombre} : {};       
            dataForm['fechadesde'] = formData.fechadesde;
            dataForm['fechahasta'] = formData.fechahasta;
            dataForm['criteriosFecha'] = formData.criterioFecha ? {id: formData.criterioFecha, glosa: criteriosFecha.find(element => element.id == formData.criterioFecha).nombre} : {};       
            dataForm['dias'] = formData.dias;
            dataForm['criterioPendiente'] = formData.criterioPendiente ? {id: formData.criterioPendiente, glosa: criteriosPendiente.find(element => element.id == formData.criterioPendiente).nombre} : {};       

            //console.log("dataForm: ", dataForm);
            try {
                dispatch(generarInforme(dataForm))
                .then(() => {
                    let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
                    dispatch(obtenerInformesPrevios(query));
                })
                .then(()=>setLoading(false))
            } catch (error) {
                setLoading(false)
                console.log("error: ", error);
            }

        }
    })
    useEffect(() => {
        let excel = respuestaGenerar && respuestaGenerar.respuestaGenerar.object;
        console.log("excel: ", excel);
        if (excel) {

            setLoading(false);
            
            var link = document.createElement("a");
            link.download = excel.filename;
            link.href = "data:" + excel.mimetype + ";base64," + excel.xlsxfile;
            link.click();
        }

    }, [respuestaGenerar]);

    const handleLimpliar=()=>{
        formik.resetForm();
        setIsDias(false);
        setIsfechas(false);
    }
    const handleChangeTipoInforme=(tipoInforme)=>{
        let tg = "235001"; //Recupero
        if (tipoInforme == 282002)  {
            tg = "235005"; //Defensa
        }
        setTipoGestion(tg);
        let query = Buffer.from(JSON.stringify({ tipoInforme: tipoInforme, idFiltro:288001})).toString('base64')
        dispatch(obtenerEstados(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({rutcia: rutOrganizacion, concepto: 281})).toString('base64')
            dispatch(obtenerCriteriosFecha(query))
        })
        .then(()=>{
            let query = Buffer.from(JSON.stringify({concepto: 283})).toString('base64')
            dispatch(obtenerCriteriosPendiente(query))
        })
    }
    return (      
    <>
      <style type='text/css'>
        {`
        .btn-limpiar {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
            
        }
        .btn-buscar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
      
          }
        `}
        </style>
        <LoadingComponent show={loading}/>
        <Form onSubmit={formik.handleSubmit}>
        <Container>
            <Container>            
            {cfg_formInf? (
                <div >                  
                    <Row >                 
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf['informes-filtro-tipo-informe'] : "Tipo Informe"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    //setTipoGestion(e.target.value == 282001 ? 235001 : 235005);
                                    handleChangeTipoInforme(e.target.value);
                                }}
                                name='tipoInforme'
                                value={(formik.values.tipoInforme)}
                                error={formik.errors.tipoInforme}
                            >
                            <option value={''}>Seleccione...</option>
                            {tiposInforme &&
                                tiposInforme?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.tipoInforme ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.tipoInforme}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                    </Row>
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'10px' }}></hr>
                    <Row >                 
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-compania']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='compania'
                                value={(formik.values.compania)}
                                error={formik.errors.compania}
                            >
                            <option value={''}>Seleccione...</option>
                            {companias &&
                                companias?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.compania ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.compania}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-estado']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='estado'
                                value={(formik.values.estado)}
                                error={formik.errors.estado}
                            >
                            <option value={''}>Seleccione...</option>
                            {estados && estados
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.estado ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.estado}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-situacion']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='situacion'
                                value={(formik.values.situacion)}
                                error={formik.errors.situacion}
                            >
                            <option value={''}>Seleccione...</option>
                            {situaciones &&
                                situaciones?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.situacion ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.situacion}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                    </Row>
                    <Row >                 
                        <Col md='2'>
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-fecha-desde']}
                            </Form.Label>{' '}
                            <br />                   
                            <Form.Control type='date'
                                name='fechadesde'
                                value={formik.values.fechadesde}
                                onChange={(e)=>{
                                    formik.handleChange(e)     
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>                
                        </Col>
                        <Col md='2' >
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-fecha-hasta']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Control type='date'
                                name='fechahasta'
                                value={formik.values.fechahasta}
                                onChange={(e)=>{
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>
                        </Col>
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-criterio-fecha']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                                name='criterioFecha'
                                value={(formik.values.criterioFecha)}
                                error={formik.errors.criterioFecha}
                            >
                            <option value={''}>Seleccione...</option>
                            {criteriosFecha && criteriosFecha
                                ?.filter(p => (p.agrupacion == 0 || p.agrupacion == tipoGestion))
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.criterioFecha ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.criterioFecha}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='1'>
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-dias']}
                            </Form.Label>{' '}
                            <Form.Control
                                onChange={(e)=>{
                                    formik.handleChange(e)
                                    setIsDias(true);
                                }}
                                value={formik.values.dias}
                                name='dias'
                                error={formik.values.error}                                 
                            />
                            {formik.errors.dias ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                {formik.errors.dias}
                                </Form.Text>
                            ) : (
                                ''
                            )}
                        </Col>
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-filtro-criterio-pend']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    setIsDias(true);
                                }}
                                name='criterioPendiente'
                                value={(formik.values.criterioPendiente)}
                                error={formik.errors.criterioPendiente}
                            >
                            <option value={''}>Seleccione...</option>
                            {criteriosPendiente && criteriosPendiente
                                ?.filter(p => (p.agrupacion == 0 || p.agrupacion == tipoGestion))
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.criterioPendiente ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.criterioPendiente}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                    </Row>
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                    <Row className='mt-2'>                            
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                            <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf["informes-filtro-btn-limpiar"] : "Limpiar"}
                            </Button>
                            <Button className='m-2' variant='buscar' type='onSubmit' >
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf["informes-filtro-btn-gen-informe"] : "Generar Informe"}
                            </Button>                            
                        </Col>
                    </Row>
                </div>
            ) : ""}
            </Container>
        </Container>
        </Form>
    </>
  )
}
export default FiltrosInforme 